import { type BadgeVariant, TextCaption } from '@carboncopyco/ui';
import {
  BadgeWithTooltip,
  type BadgeWithTooltipProps,
} from '../BadgeWithTooltip';

export type RecordingTypeBadgeProps = {
  recordingType: RecordingType;
  darkMode?: boolean;
};

export enum RecordingType {
  Clone = 'clone',
  Overlay = 'overlay',
}

const configByRecordingType = (
  variant: BadgeVariant
): Record<RecordingType, BadgeWithTooltipProps> => ({
  [RecordingType.Clone]: {
    tooltipText: (
      <TextCaption
        label="This demo is based on a cloned environment, so you can share it and use advanced editing."
        color="text-ds-natural-400"
      />
    ),
    badgeProps: {
      size: 'sm',
      variant,
      label: 'Cloned App',
    },
  },

  [RecordingType.Overlay]: {
    tooltipText: (
      <TextCaption
        label={
          <>
            This demo is based on a production environment, so a login is
            required to present, edit, or preview it.{' '}
            <a
              href="https://help.demostack.com/en/articles/6887194"
              rel="noreferrer"
              target="_blank"
              className="underline text-ds-200 text-ds-natural-400"
            >
              Learn more
            </a>
          </>
        }
        color="text-ds-natural-400"
      />
    ),
    badgeProps: {
      size: 'sm',
      variant,
      label: 'Live App',
    },
  },
});
export const RecordingTypeBadge = ({
  recordingType,
  darkMode = false,
}: RecordingTypeBadgeProps) => {
  const variant = darkMode ? 'dark' : 'primary';
  const badgeConfig = configByRecordingType(variant);

  return <BadgeWithTooltip {...badgeConfig[recordingType]} />;
};
